module.exports = __webpack_public_path__ + "img/instagram-icon-white.69933e18.svg";